<template>
  <div class="row">
    <div class="col">
      <form @submit.prevent="submit"
            autocomplete="no"
            @keydown="clearError($event)"
      >
        <div class="row mb-2">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Vendor Name</label>
              <input v-model="vendor.name"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Name On Check</label>
              <input v-model="vendor.nameOnCheck"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="nameOnCheck" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Company Name</label>
              <input v-model="vendor.companyName"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="companyName" />
          </div>
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Short Name</label>
              <input v-model="vendor.shortName"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="shortName" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Address</label>
              <input v-model="vendor.address1"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="address1" />
          </div>
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>City</label>
              <input v-model="vendor.addressCity"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="addressCity" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>State</label>
              <simple-select v-model="vendor.addressState"
                             :options="states"
                             placeholder="Select State"
                             autocomplete="no"
              />
            </div>
            <error-field :errors="errors" field="addressState" />
          </div>
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>ZIP Code</label>
              <input v-model="vendor.addressZip"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="addressZip" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col pr-1">
            <div class="select-wrap">
              <label>Address 2</label>
              <input v-model="vendor.address2"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="address2" />
          </div>
        </div>

        <div class="row mb-2">
          <div class="col pr-1">
            <div class="select-wrap">
              <label>Account number</label>
              <input v-model="vendor.accNumber"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="accNumber" />
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Tax ID</label>
              <input v-model="vendor.taxId"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="taxId" />
          </div>
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Tax ID Type</label>
              <simple-select
                placeholder="Select"
                :options="taxIdTypes"
                v-model="vendor.taxIdType"
                :hide-select="true"
              />
            </div>
            <error-field :errors="errors" field="taxIdType" />
          </div>
        </div>
        <div class="row mb-2" v-if="!company.company_billing">
          <div class="col">
            <div class="check-field">
              <label :class="[vendor.sendRequest ? 'check-open' : 'check-closed']" for="send-request">
                <span class="checkmark" />
                Also send me an invitation to join Bill.com and receive electronic payments
                <input type="checkbox"
                       v-model="vendor.sendRequest"
                       value="1"
                       id="send-request"
                       class="btn-check"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row mb-2" v-if="!company.company_billing && vendor.sendRequest">
          <div class="col">
            <div class="select-wrap">
              <label for="request-email">Email</label>
              <input v-model="vendor.requestEmail"
                     id="request-email"
                     name="request-email"
                     type="text"
                     class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row mt-3 mb-3">
          <div class="col text-right">
            <button type="button"
                    class="btn btn-secondary"
                    @click="$emit('cancel')"
            >
              Cancel
            </button>
            <button class="btn btn-primary ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled || !formInvalid"
            >
              Submit
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import toastr from 'toastr';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';

export default {
  name: 'Check',
  components: {
    ErrorField,
  },
  props: {
    company: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    booleanOptions: [{ id: 1, name: 'Yes' }, { id: 0, name: 'No' }],
    buttonDisabled: false,
    errors: new Errors(),
    loadingButton: false,
    taxIdTypes: [{ id: '1', name: 'ein' }, { id: '2', name: 'ssn' }],
    vendor: {
      accNumber: '',
      address1: '',
      address2: '',
      addressCity: '',
      addressState: '',
      addressZip: '',
      companyName: '',
      name: '',
      nameOnCheck: '',
      requestEmail: '',
      sendRequest: 0,
      shortName: '',
      taxId: '',
      taxIdType: '',
    },
  }),
  computed: {
    ...mapState({
      states: state => state.values.states,
    }),
    formInvalid() {
      return !!this.vendor.name;
    },
  },
  mounted() {
    if (!this.states.length) {
      this.getStates();
    }
    this.setVendorDefaults();
  },
  methods: {
    ...mapActions(['getStates']),
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    setVendorDefaults() {
      if (!this.company.company_billing) {
        this.vendor.address1 = this.company.address;
        this.vendor.address2 = this.company.address2;
        this.vendor.addressCity = this.company.city;
        this.vendor.addressState = parseInt(this.company.state_id, 10);
        this.vendor.addressZip = this.company.zip;
        this.vendor.companyName = this.company.name;
        this.vendor.name = this.company.name;
        this.vendor.requestEmail = this.company.email;
      } else {
        this.vendor.accNumber = this.company.company_billing.account_number;
        this.vendor.address1 = this.company.company_billing.address1;
        this.vendor.addressCity = this.company.company_billing.address_city;
        this.vendor.addressState = parseInt(this.company.company_billing.address_state_id, 10);
        this.vendor.addressZip = this.company.company_billing.address_zip;
        this.vendor.companyName = this.company.company_billing.company_name;
        this.vendor.name = this.company.company_billing.name;
        this.vendor.nameOnCheck = this.company.company_billing.name_on_check;
        this.vendor.shortName = this.company.company_billing.short_name;
        this.vendor.taxId = this.company.company_billing.tax_id;
        this.vendor.taxIdType = this.company.company_billing.tax_id_type;
      }
    },
    submit() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      if (!this.company.company_billing) {
        axios
          .post(`companies/${this.company.id}/bill/vendor`, this.vendor)
          .then(() => {
            toastr.success('Successfully updated billing information.');
            this.$emit('saved');
          })
          .catch(err => this.errors.record(err.response.data.error))
          .finally(() => {
            this.buttonDisabled = false;
            this.loadingButton = false;
          });
      } else {
        axios
          .put(`companies/${this.company.id}/bill/vendor`, this.vendor)
          .then(() => {
            toastr.success('Successfully updated billing information.');
            this.$emit('saved');
          })
          .catch(err => this.errors.record(err.response.data.error))
          .finally(() => {
            this.buttonDisabled = false;
            this.loadingButton = false;
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/companies/mod24settings/Check.vue